import Nav from '../../components/NavigationBar';
import Layout from '../../components/Layout';
import Utils from '../../../utils';
import { useNavigate } from 'react-router-dom';
import React, { useState, useRef, useEffect } from 'react';
import { manifestConfiguration } from '../../../router/configuration';
import {
    Container,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    MenuItem,
    Select,
    styled,
    Typography
} from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PaymentIcon from '@mui/icons-material/Payment';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import LanguageIcon from '@mui/icons-material/Language';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LogoutIcon from '@mui/icons-material/Logout';
import deleteIcon from '../../../../src/assets/image/png/delete.png';
import logout from '../../assets/logout.png';
import { OutlinedButton } from '../../common/inputs/Button';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAccountAPI } from '../../modules/Auth/Action';
import { translate } from '../../../helper';
import i18n from '../../../I18';
import LocalStorage from '../../../defined/localStorage';
import './style.css';
import { logoutCleanup } from '../../../utils/logoutCleanup';
import { userDetailApiCall } from '../../modules/UserProfile/Action';
import DownloadIcon from '@mui/icons-material/Download';
import { usePWAInstall } from '../../../hooks/usePWAInstall';

const brand = JSON.parse(LocalStorage.getItem('branding'));

const PageBox = styled('div')(({ }) => ({
    'position': 'relative',
    'width': '100%',
    'textAlign': 'center',
    'height': '100%',
    'overflowY': 'auto',
    pointerEvents: 'auto',
    touchAction: 'manipulation',
    WebkitTouchCallout: 'none',
    userSelect: 'none',
    backfaceVisibility: 'hidden',
}));

function Settings(props) {
    const { data: authData } = useSelector(state => state.auth);
    const brand = useSelector((state) => state?.User?.branding) || JSON.parse(LocalStorage.getItem('branding'))
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [openLanguageSelector, setOpenLanguageSelector] = useState(false);
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
    const endpointType = props.dt ? 'dealerTechnicianEndpoints' : 'userMobileEndpoints';

    const {
        installAvailable,
        installing,
        isStandalone,
        installApp,
        isAndroid
    } = usePWAInstall()

    React.useEffect(() => {
        userDetailApiCall(dispatch, authData);
    }, [dispatch]);

    React.useEffect(() => {
        manifestConfiguration(brand);
    }, [brand]);

    const handleClose = () => {
        setOpen(false);
        setIsLogoutModalOpen(false);
    };

    const handleLogout = () => {
        runLogoutCleanup();
        Utils.showAlert(1, 'Logout successfully');
    };

    const runLogoutCleanup = () => {
        logoutCleanup({ dispatch, navigate, endpointType });
    };


    return (
        <Layout showCentreProfile showLargeHeader centreProfile>
            <PageBox className="settings"
                sx={{
                    'backgroundColor': 'white',
                    'paddingTop': '10px'
                }}
            >
                <Nav style={{ marginTop: '20px' }} path={Utils.EndPoint[endpointType].updateProfile}
                    label={translate('myProfile')} icon={<PersonOutlineIcon />} iconColor="#6C5CE7" />
                {!props.dt &&
                    <Nav path={Utils.EndPoint.userMobileEndpoints.paymentMethod} label={translate('payment')} icon={<PaymentIcon />} iconColor="#00B894" />}
                <Nav path={Utils.EndPoint[endpointType].changePassword} label={translate('changePassword')} icon={<LockOutlinedIcon />} iconColor="#0984E3" />
                <Nav path={Utils.EndPoint[endpointType].notifications} label={translate('notifications')} icon={<NotificationsOutlinedIcon />} iconColor="#FDCB6E" />
                <Nav path={Utils.EndPoint[endpointType].installationGuide} label={translate('installationGuide')} icon={<MenuBookOutlinedIcon />} iconColor="#00CEC9" />
                {isAndroid && !isStandalone && installAvailable && (
                    <Nav
                        onClick={installApp}
                        label={installing ? 'Installing...' : 'Install App'}
                        icon={<DownloadIcon />}
                        iconColor="#2D3436"
                    />
                )}
                <Nav path={Utils.EndPoint[endpointType].terms} label={translate('termsAndConditions')} icon={<DescriptionOutlinedIcon />} iconColor="#74B9FF" />
                <Nav path={Utils.EndPoint[endpointType].privacy} label={translate('privacyAndPolicy')} icon={<PrivacyTipOutlinedIcon />} iconColor="#A29BFE" />
                <Nav onClick={() => setOpen(true)} label={translate('deleteAccount')} icon={<DeleteOutlineIcon />} danger />
                <Nav onClick={() => setOpenLanguageSelector(true)} label={translate('chooseLanguage')} icon={<LanguageIcon />} iconColor="#636E72" />
                <Nav onClick={() => window.zE("messenger", "show")} label={translate('support')} icon={<SupportAgentIcon />} iconColor="#E17055" />
                <Nav onClick={() => setIsLogoutModalOpen(true)} label={translate('log_out')} icon={<LogoutIcon />} danger />
            </PageBox>
            <Container>
                <div>
                    {
                        openLanguageSelector && (
                            <LanguageSelectionModal
                                isOpen={openLanguageSelector}
                                onClose={() => setOpenLanguageSelector(false)}
                            />
                        )
                    }
                    <Dialog fullWidth={true} open={open || isLogoutModalOpen} onClose={handleClose}>
                        <DialogTitle style={{ textAlign: 'center' }}>
                            <img style={{ width: '100px', height: '87px' }} src={open ? deleteIcon : logout} />
                            <Typography fontSize={'16px'} fontWeight={'400'}
                                margin={'30px 0'}>{open ? translate('accountDeletingConfirmation') : translate('logoutConfirmation')} </Typography>
                            <Typography fontSize={'16px'} fontWeight={'600'}
                                margin={'20px 0'}>{translate('confirmation')}?</Typography>
                        </DialogTitle>
                        <DialogContent style={{ padding: '30px 0 0 0' }}>
                            <DialogContentText style={{ display: 'flex' }}>
                                <div style={{ width: '50%' }} className="warningButton" onClick={() => handleClose()}>
                                    <OutlinedButton style={{
                                        width: '100%',
                                        border: 'none',
                                        borderTop: '1px solid rgba(255, 255, 255, 0.5)',
                                        borderRadius: 0,
                                        borderRight: '1px solid rgba(255, 255, 255, 0.5)',
                                        boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.25)',
                                        color: '#000'
                                    }} type="submit">{translate('no')}</OutlinedButton>
                                </div>
                                <div style={{ width: '50%' }} className="warningButton">
                                    <OutlinedButton style={{
                                        width: '100%',
                                        border: 'none',
                                        borderTop: '1px solid rgba(255, 255, 255, 0.5)',
                                        borderRadius: 0,
                                        borderRight: '1px solid rgba(255, 255, 255, 0.5)',
                                        boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.25)',
                                        color: '#FF2020'
                                    }} type="submit" onClick={() => {
                                        if (open) {
                                            deleteAccountAPI(runLogoutCleanup);
                                            return;
                                        }
                                        if (isLogoutModalOpen) {
                                            handleLogout();
                                        }
                                    }}>{translate('yes')}</OutlinedButton>
                                </div>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>
                </div>
            </Container>
        </Layout>
    );
}

const LanguageSelectionWrapper = styled('div')(({ theme }) => ({
    '& .MuiInputBase-root': {
        'width': '100%'
    }
}));

const LanguageSelectionModal = ({ isOpen, onClose }) => {

    const [language, setLanguage] = React.useState('');

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
        >
            <DialogTitle>{translate('chooseLanguage')}</DialogTitle>
            <DialogContent style={{ paddingTop: "20px" }}>
                <LanguageSelectionWrapper>
                    <Select
                        displayEmpty
                        onChange={(evt) => {
                            setTimeout(() => {
                                i18n.changeLanguage(evt.target.value, () => {
                                    window.location.reload();
                                });
                                setLanguage(evt.target.value);
                            }, 500);
                        }}
                        value={language}
                        id="languages"
                        renderValue={
                            language !== ''
                                ? undefined
                                : () => <span style={{ color: '#ababab' }}>{translate('selectLanguage')}</span>
                        }
                    >
                        <MenuItem value={'en'}>English</MenuItem>
                        <MenuItem value={'es'}>Spanish</MenuItem>
                    </Select>
                </LanguageSelectionWrapper>
            </DialogContent>
        </Dialog>
    );
};

export default Settings;